// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import { TaskStatusesFragmentDoc, TaskDetailPaneFragmentDoc, TaskDateEditabilityFragmentDoc, ResultingDelayResponseFragmentDoc, ScheduleSettingDetailsFragmentDoc, InternalUserDetailFragmentDoc, TaskFilterOptionsFragmentDoc, ProjectScheduleDocumentDetailFragmentDoc, ProjectRoleDetailsFragmentDoc } from '../../../../fragments/circularFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddDepositModalQueryVariables = Types.Exact<{
  commitmentId: Types.Scalars['ID']['input'];
  projectId: Types.Scalars['ID']['input'];
  stage: Types.Stage;
}>;


export type AddDepositModalQuery = { __typename?: 'Query', commitment: { __typename?: 'Commitment', id: string, status: Types.CommitmentStatus, depositInBasisPoints?: number | null | undefined, costChangeInCents: number, canBeEdited: boolean, depositScheduleTask?: { __typename?: 'Task', id: string, name: string, status: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus, name: string, sortOrder: number } } | null | undefined }, tasks: Array<{ __typename?: 'Task', id: string, name: string, status: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus, name: string, sortOrder: number } }> };


export const AddDepositModalDocument = gql`
    query AddDepositModal($commitmentId: ID!, $projectId: ID!, $stage: Stage!) {
  commitment(id: $commitmentId) {
    id
    status
    depositInBasisPoints
    costChangeInCents
    depositScheduleTask {
      ...Named
      status {
        ...TaskStatuses
      }
    }
    canBeEdited
  }
  tasks(
    filter: {scheduleParent: [$projectId], stage: [$stage], status: [NOT_STARTED, IN_PROGRESS, ON_HOLD, DELAYED]}
  ) {
    ...Named
    status {
      ...TaskStatuses
    }
  }
}
    ${NamedFragmentDoc}
${TaskStatusesFragmentDoc}`;

/**
 * __useAddDepositModalQuery__
 *
 * To run a query within a React component, call `useAddDepositModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddDepositModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddDepositModalQuery({
 *   variables: {
 *      commitmentId: // value for 'commitmentId'
 *      projectId: // value for 'projectId'
 *      stage: // value for 'stage'
 *   },
 * });
 */
export function useAddDepositModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddDepositModalQuery, AddDepositModalQueryVariables> & ({ variables: AddDepositModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddDepositModalQuery, AddDepositModalQueryVariables>(AddDepositModalDocument, options);
      }
export function useAddDepositModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddDepositModalQuery, AddDepositModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddDepositModalQuery, AddDepositModalQueryVariables>(AddDepositModalDocument, options);
        }
export function useAddDepositModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddDepositModalQuery, AddDepositModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddDepositModalQuery, AddDepositModalQueryVariables>(AddDepositModalDocument, options);
        }
export type AddDepositModalQueryHookResult = ReturnType<typeof useAddDepositModalQuery>;
export type AddDepositModalLazyQueryHookResult = ReturnType<typeof useAddDepositModalLazyQuery>;
export type AddDepositModalSuspenseQueryHookResult = ReturnType<typeof useAddDepositModalSuspenseQuery>;
export type AddDepositModalQueryResult = Apollo.QueryResult<AddDepositModalQuery, AddDepositModalQueryVariables>;